import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess240007ParamStatus: 'idle',
    startProcess240007ParamError: undefined as any,
    loadUserParamsProcess240007ParamStatus: 'idle',
    loadUserParamsProcess240007ParamError: undefined as any,

    process240007ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess240007Param = createAsyncThunk('process240007ParamSlice/startProcess240007Param', async ({ process240007Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess240007Param/`,
        prepareData(process240007Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess240007ParamStatus } = getState().process240007ParamSlice
        return startProcess240007ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess240007Param = createAsyncThunk('process240007ParamSlice/loadUserParamsProcess240007Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess240007Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess240007ParamStatus } = getState().process240007ParamSlice
        return loadUserParamsProcess240007ParamStatus !== 'pending'
    }
})

const Process240007ParamSlice = createSlice({
    name: 'process240007ParamSlice',
    initialState,
    reducers: {
        resetstartProcess240007Param: (state) => {
            state.job = undefined
            state.startProcess240007ParamError = undefined
        },
        resetstartProcess240007ParamError: (state) => {
            state.startProcess240007ParamError = undefined
        },
        resetloadUserParamsProcess240007Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess240007ParamError = undefined
        },
        resetloadUserParamsProcess240007ParamError: (state) => {
            state.loadUserParamsProcess240007ParamError = undefined
        },
        removeFromProcess240007ParamListById: (state, action) => {
            state.process240007ParamList = state.process240007ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess240007ParamListByIds: (state, action) => {
            state.process240007ParamList = state.process240007ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process240007ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess240007ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process240007ParamList = []
            state.startProcess240007ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess240007Param.pending, (state) => {
            state.startProcess240007ParamStatus = 'pending'
            state.startProcess240007ParamError = undefined
        })
        builder.addCase(startProcess240007Param.fulfilled, (state, action) => {
            state.startProcess240007ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess240007Param.rejected, (state, action) => {
            state.startProcess240007ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess240007ParamError = action.error.message
            } else {
                state.startProcess240007ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess240007Param.pending, (state) => {
            state.loadUserParamsProcess240007ParamStatus = 'pending'
            state.loadUserParamsProcess240007ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess240007Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess240007ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess240007Param.rejected, (state, action) => {
            state.loadUserParamsProcess240007ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess240007ParamError = action.error.message
            } else {
                state.loadUserParamsProcess240007ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess240007Param,
    resetstartProcess240007ParamError,
    resetloadUserParamsProcess240007Param,
    resetloadUserParamsProcess240007ParamError,
    removeFromProcess240007ParamListById,
    removeFromProcess240007ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process240007ParamSlice.actions
export default Process240007ParamSlice.reducer
